// Auto-format a US phone number as it's typed, e.g. 1-917-903-8922.
// - A leading "1" is treated as the country code (area codes never start with 1).
// - Without a leading 1, formats a 10-digit number as 917-903-8922.
export function formatPhone(raw) {
  let d = String(raw ?? "").replace(/\D/g, "");
  if (!d) return "";

  if (d[0] === "1") {
    d = d.slice(0, 11);
    const rest = d.slice(1);
    const parts = ["1"];
    if (rest.slice(0, 3)) parts.push(rest.slice(0, 3));
    if (rest.slice(3, 6)) parts.push(rest.slice(3, 6));
    if (rest.slice(6, 10)) parts.push(rest.slice(6, 10));
    return parts.join("-");
  }

  d = d.slice(0, 10);
  const parts = [];
  if (d.slice(0, 3)) parts.push(d.slice(0, 3));
  if (d.slice(3, 6)) parts.push(d.slice(3, 6));
  if (d.slice(6, 10)) parts.push(d.slice(6, 10));
  return parts.join("-");
}
